module.exports = __webpack_public_path__ + "static/media/Inter-MediumItalic.16f319ce.woff";